<template>
	<div class="wrapper-admin">
		<div class="ho-app ho-app-admin">
			<div class="admin-nav flex w-full items-center">
				<h2 class="flex-none mr-8">{{ localization.t("app.administration") }}</h2>
				<nav class="flex flex-auto gap-x-6">
					<router-link class="admin-nav-link" :to="{ name: 'Users' }">
						{{ localization.t("administration.users.title") }}
					</router-link>
					<router-link class="admin-nav-link" :to="{ name: 'Organizations' }">
						{{ localization.t("administration.organizations.title") }}
					</router-link>
				</nav>
				<button class="btn flex" @click="goToHome">
					<span class="w-8 h-8 text-center"><home-icon class="w-7 h-7" /></span>
					{{ localization.t("administration.home") }}
				</button>
			</div>
			<div class="admin-content">
				<RouterView :user="user" />
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import IUser from '@/interfaces/users/iUser';
import { RouterView } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { HomeIcon } from '@heroicons/vue/outline';
import router from '@/router';

defineProps({
	user: {
		type: Object as () => IUser,
	},
});

const localization = useI18n();

const goToHome = () => router.push("/vat-explorer");
</script>

<style lang="postcss" scoped>
.ho-app-admin {
	width: 1280px;
	margin: auto;
	height: 100%;
}

.admin-nav {
	height: 60px;
	@apply border-b border-gray-200;
}

.admin-nav-link {
	@apply text-xl text-gray-500 py-4 border-b-2 border-transparent;
}

.admin-nav-link.router-link-active {
	@apply text-peri-500 border-peri-500;
}

.admin-content {
	height: calc(100% - 60px);
}
</style>
